export default {"src":"/_next/static/media/afs_white_01.fa6528df.svg","height":106,"width":435,"blurWidth":0,"blurHeight":0};